'use strict';

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function parseHexColor(value) {
  const text = String(value || '').trim();
  const short = /^#([0-9a-f]{3})$/i.exec(text);
  if (short) return short[1].split('').map((part) => parseInt(part + part, 16));
  const full = /^#([0-9a-f]{6})$/i.exec(text);
  if (full) return [0, 2, 4].map((offset) => parseInt(full[1].slice(offset, offset + 2), 16));
  return [70, 230, 255];
}

function mixColor(source, target, amount) {
  const ratio = clamp(Number(amount) || 0, 0, 1);
  const channels = source.map((channel, index) => Math.round(channel + (target[index] - channel) * ratio));
  return `rgb(${channels[0]}, ${channels[1]}, ${channels[2]})`;
}

function createSparkles(progress, timeSeconds, level) {
  const count = clamp(Math.floor((progress - 0.28) * 6.2), 0, 4);
  const sparkles = [];
  for (let index = 0; index < count; index += 1) {
    const phase = timeSeconds * (1.15 + index * 0.09) + level * 0.21 + index * 1.73;
    const side = index % 2 === 0 ? -1 : 1;
    sparkles.push({
      x: side * (29 + index * 3) + Math.sin(phase * 0.7) * 5,
      y: -26 + index * 17 + Math.cos(phase * 0.6) * 5,
      radius: 1.5 + progress * 2.2 + (index % 2) * 0.8,
      alpha: clamp(0.25 + progress * 0.55 + Math.sin(phase * 2.1) * 0.18, 0.12, 1)
    });
  }
  return sparkles;
}

function getPlaneRadiance(level, baseColor, timeSeconds) {
  const safeLevel = clamp(Math.floor(Number(level) || 1), 1, 99);
  const progress = (safeLevel - 1) / 98;
  const time = Number.isFinite(Number(timeSeconds)) ? Number(timeSeconds) : 0;
  const pulse = 0.5 + Math.sin(time * (2.05 + progress * 0.45) + safeLevel * 0.17) * 0.5;
  const source = parseHexColor(baseColor);
  return Object.freeze({
    level: safeLevel,
    progress,
    color: mixColor(source, [255, 248, 220], progress * 0.62),
    highlightColor: mixColor(source, [255, 255, 255], 0.48 + progress * 0.44),
    glowColor: mixColor(source, [255, 239, 165], progress * 0.58),
    glowBlur: 20 + progress * 40 + pulse * progress * 10,
    glowAlpha: clamp(0.38 + progress * 0.42 + pulse * progress * 0.12, 0, 0.96),
    pulse,
    sparkles: Object.freeze(createSparkles(progress, time, safeLevel))
  });
}

module.exports = { clamp, parseHexColor, mixColor, getPlaneRadiance };
